<div class="scrollContainerAndNoEntriesCon">
	@if (scrollEntries?.length === 0) {
		<div class="noEntriesCon" [@fadeInOnEnter]>
			<div class="noEntriesIcon">
				<i class="fad fa-empty-set fa-3x"></i>
			</div>
			<div class="noEntriesText">
				@if (translationKeyForEmptySet) {
					{{ translationKeyForEmptySet | translate }}
				} @else {
					{{ T.GENERAL_TXT_LIST_EMPTY | translate }}
				}
			</div>
		</div>
	}

	<div class="fixedHeaderCon">
		<ng-content />
	</div>

	<div class="scrollContainer" [style.height]="scrollContainerHeightInPX + 'px'" [@listStagger]="scrollEntries?.length">
		@for (scrollEntry of scrollEntries; track scrollEntry) {
			<div class="scrollEntryCon">
				<div class="displayText showDotsOnOverflow1">
					{{ getScrollEntryText(scrollEntry) }}
				</div>
				<div class="removeEntry">
					<button (click)="removeEntry(scrollEntry)" color="warn" mat-icon-button>
						<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline />
					</button>
				</div>
			</div>
		}
	</div>
</div>
